import { render, staticRenderFns } from "./PeriodPicker.vue?vue&type=template&id=51ee869d&"
import script from "./PeriodPicker.vue?vue&type=script&lang=js&"
export * from "./PeriodPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ee869d')) {
      api.createRecord('51ee869d', component.options)
    } else {
      api.reload('51ee869d', component.options)
    }
    module.hot.accept("./PeriodPicker.vue?vue&type=template&id=51ee869d&", function () {
      api.rerender('51ee869d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/PeriodPicker.vue"
export default component.exports